import { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

import { withErrorApi } from '@hoc-helpers/withErrorApi';
import PeopleList from '@components/PeoplePage/PeopleList';
import PeopleNavigation from '@components/PeoplePage/PeopleNavigation';
import { getApiResource, changeHTTP } from '@utils/network';
import { getPeopleId, getPeopleImage, getPeoplePageId } from '@services/getPeopleData';
import { AIP_PEOPLE } from '@constans/api';
import { useQueryParams } from '@hooks/useQueryParams';


const PeoplePage = ({ setErrorApi }) => {
    const [people, setPeople] = useState(null);
    const [prevPage, setPrevPage] = useState(null);
    const [nextPage, setNextPage] = useState(null);
    const [counterPage, setCounterPage] = useState(1);

    const query = useQueryParams();
    const queryPage = query.get('page');

    const getResource = useCallback(async (url) => {
        const res = await getApiResource(url);

        if(res) {
            const peopleList = res.results.map(({name, url}) => {
                const id = getPeopleId(url);
                const img = getPeopleImage(id);
    
                return {
                    id,
                    name,
                    img
                }
            })
            setPeople(peopleList);
            setPrevPage(changeHTTP(res.previous));
            setNextPage(changeHTTP(res.next));
            setCounterPage(getPeoplePageId(url));
            setErrorApi(false);
        }else {
            setErrorApi(true);
        }
    }, [setErrorApi]);


    useEffect(() => {
        getResource(AIP_PEOPLE + (queryPage || 1));
    }, [getResource, queryPage]);

   return (
       <>
            <PeopleNavigation 
                getResource = {getResource}
                prevPage = {prevPage}
                nextPage = {nextPage}
                counterPage = {counterPage}
            />
            {people && <PeopleList people={people} />}
       </>
   )
}


withErrorApi.propTypes = {
    setErrorApi: PropTypes.func
}

export default withErrorApi(PeoplePage);
